<template>
	<div :class="['reviewer-info', blockClassModifier]">
		<h4 class="reviewer-info__name">
			{{ travelerName }}
		</h4>
		<p class="reviewer-info__age">
			Alter: <span>{{ review.Age }}</span>
		</p>
		<p class="reviewer-info__info">verreist als {{ capitalize(review.TravelledAs) }} im {{ travelDate }}</p>
	</div>
</template>

<script lang="ts" setup>
import { capitalize, computed } from 'vue';
import { formatDate } from '@/js/utils/dateTimeUtils';
import type { ReviewType } from '@/interfaces/review-types';

interface Props {
	review: ReviewType;
	size?: 'sm' | 'md';
}

const { size = 'md', review } = defineProps<Props>();

const travelerName = computed((): string => {
	const { FirstName, Title } = review;
	return `${Title} ${FirstName}`;
});

const blockClassModifier = computed((): string => (size ? `reviewer-info--${size}` : ''));

const travelDate = computed((): string => {
	const date = new Date();
	const { YearOfTravel, MonthOfTravel } = review;
	date.setFullYear(YearOfTravel);
	date.setMonth(MonthOfTravel - 1);
	return formatDate(date, { year: 'numeric', month: 'long' });
});
</script>

<style scoped lang="scss">
.reviewer-info {
	display: flex;
	flex-flow: column;
	font-weight: $font-weight-semibold;
	line-height: 2.3rem;

	& > * {
		margin: 0;
		padding: 0;
	}

	&__name {
		font-size: $font-small-1;
		font-weight: $font-weight-semibold;
	}

	&__info {
		color: $color-placeholder-text;
	}

	&__age {
		span {
			font-weight: $font-weight-regular;
		}
	}

	&--sm {
		.reviewer-info__name {
			font-size: $font-small-2;
		}

		.reviewer-info__age,
		.reviewer-info__info {
			font-size: $font-small-3;
		}
	}

	@include media-query-up($breakpoint-small) {
		.reviewer-info__name {
			font-size: $font-small-1;
		}

		.reviewer-info__age,
		.reviewer-info__info {
			font-size: $font-small-2;
		}
	}
}
</style>
